/**
 * Bundle Composition — variant change handler
 * Re-fetches the section HTML via Section Rendering API on variant change
 * and swaps the bundle composition contents for the new variant.
 */
(function () {
  document.addEventListener('variant:change', function (e) {
    var variant = e.detail && e.detail.variant;
    if (!variant) return;

    var targets = document.querySelectorAll('[data-bundle-composition]');
    if (!targets.length) return;

    var sectionId = e.detail.sectionId;
    if (!sectionId) return;

    var url =
      window.location.pathname +
      '?variant=' + variant.id +
      '&section_id=' + sectionId;

    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newNodes = doc.querySelectorAll('[data-bundle-composition]');
        targets.forEach(function (target, index) {
          var replacement = newNodes[index] || newNodes[0];
          if (replacement) {
            target.innerHTML = replacement.innerHTML;
          }
        });
      })
      .catch(function () { /* swallow network errors silently */ });
  });
})();
